import {
  InvoiceResource,
  invoiceResourceSchema,
} from "@client/resources/InvoiceResource";
import {
  APIMethods,
  MetadataSchema,
  PaginationApiResponse,
} from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { array, object } from "yup";

export type FetchDietitianInvoicesResponse = PaginationApiResponse<
  InvoiceResource[]
>;

export type FetchDietitianInvoicesParams = {
  unpaid?: 1;
  page?: number;
  perPage?: number;
};

const schema = object({
  data: array().of(invoiceResourceSchema).defined(),
  meta: MetadataSchema.defined(),
});

export const fetchDietitianInvoices = async (
  params?: FetchDietitianInvoicesParams,
): Promise<FetchDietitianInvoicesResponse> => {
  const queryParams: Record<string, unknown> = {};
  if (params?.unpaid !== undefined) queryParams.unpaid = params.unpaid;
  if (params?.page !== undefined) queryParams.page = params.page;
  if (params?.perPage !== undefined) queryParams.perPage = params.perPage;

  const response = await fetchData(
    "/dietitian/invoices",
    APIMethods.GET,
    undefined,
    queryParams,
  );

  return await schema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/invoices"));
};
